import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/Users/vera/Projects/Clients/Aicam/aicam.studio/aicam.studio/src/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SectionLegal"] */ "/Users/vera/Projects/Clients/Aicam/aicam.studio/aicam.studio/src/components/SectionLegal.tsx");
